import { CommonModule } from "@angular/common";
import { Component, Input, OnChanges } from "@angular/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

@Component({
    selector: "vui-progress-spinner",
    templateUrl: "./progress-spinner.component.html",
    styleUrls: ["./progress-spinner.component.scss"],
    standalone: true,
    imports: [CommonModule, MatProgressSpinnerModule],
})
export class ProgressSpinnerComponent implements OnChanges {
    @Input() mode: "determinate" | "indeterminate" = "indeterminate";
    @Input() progress: number = 0;

    ngOnChanges(): void {
        if (this.progress < 0) this.progress = 0;
        if (this.progress > 100) this.progress = 100;
    }
}
